import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useAuthContext } from './hooks/useAuthContext';
import MySideBar from "./components/SideBar"
import Userdetail from './pages/Userdetail';
import ProgramAdmin from './pages/ProgramAdmin';
import { useDispatch } from 'react-redux';
import { setId, setIsMaster } from './context/companySlice'
import { useCollection } from './hooks/useCollection';
import { setBranch } from './context/adminProgramSlice';
import MenuAppBar from './components/MenuAppBar';
import { useState } from 'react';
import SignIn from './pages/SignIn';
import SignMeUp from './pages/SignMeUp';
import AllStatsReports from './pages/AllStatsReports';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  const { user, authIsReady } = useAuthContext()
  const { data: companies } = useCollection('/Companies')
  const dispatch = useDispatch();
  const [appbarTitle, setAppbarTitle] = useState('Brukerprogram');


  if (user) {
    let foundCompany = companies && companies.filter(c => c.adminEmail === user.email)
    if (foundCompany && foundCompany.length > 0) {
      const companyId = foundCompany[0].id
      const isMaster = foundCompany[0].isMaster
      let branch = (isMaster || companyId === '') ? 'Master' : companyId
      dispatch(setId(companyId));
      dispatch(setIsMaster(isMaster));
      dispatch(setBranch(branch))
    }
  }

  const handleChangeAppbarTitle = (appbarTitle) => {
    setAppbarTitle(appbarTitle)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', height: '100%', backgroundColor: 'whitesmoke', overflow: 'auto' }}>
      {authIsReady && (
        <Router>
          {user && <MySideBar />}
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            {user && <MenuAppBar appbarTitle={appbarTitle} />}
            <Routes>
              <Route path="/" element={
                user ? (
                  <Userdetail handleChangeAppbarTitle={handleChangeAppbarTitle} />
                ) : (
                  <Navigate replace to="/login" />
                )
              } />
              <Route path="/signup" element={
                !user ? (
                  <SignMeUp />
                ) : (
                  <Navigate replace to="/userdetail/:id" element={<Userdetail />} />
                )
              } />
              <Route path="/login" element={
                !user ? (
                  <SignIn />
                ) : (
                  <Navigate replace to="/" />
                )} />
              <Route path="/userdetail/:id" element={
                user ? (
                  <Userdetail handleChangeAppbarTitle={handleChangeAppbarTitle} />
                ) : (
                  <Navigate replace to="/login" />
                )
              } />
              <Route path="/programadmin" element={
                user ? (
                  <ProgramAdmin handleChangeAppbarTitle={handleChangeAppbarTitle} />
                ) : (
                  <Navigate replace to="/login" />
                )
              } />
              <Route path="/allstatsreports" element={
                user ? (
                  <AllStatsReports handleChangeAppbarTitle={handleChangeAppbarTitle} />
                ) : (
                  <Navigate replace to="/login" />
                )
              } />
              <Route path="/privacypolicy" element={<PrivacyPolicy/>} />
            </Routes>
          </div>
        </Router>
      )}
    </div>
  );
}

export default App;
